import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import API from "../api/axiosConfig";


export function GitInfoDisplay() {

  const [isHovered, setIsHovered] = useState(false);
  const [version, setVersion] = useState("..."); // version of git hash
  const [branch, setBranch] = useState("..."); // branch of git

  const fetchVersion = async () => {
    try {
      const response = await API.get("/api/actuator/info");
      // get the latest hash from backend.  in case backend is down store unknown version
      const hash = response.data?.git?.commit?.id?.abbrev || "Unknown version";
      const branch = response.data?.git?.branch || "Unknown Branch";
      setVersion(hash);
      setBranch(branch);
    } catch (error) {
      setVersion("Unknown version");
      setBranch("Unknown Branch")
      // fallback in case backend is down and cache is empty still want to display something
    }
  };

  useEffect(() => {
    fetchVersion();
  }, []);

  return (
    <Box
      component="footer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 9999,
        backgroundColor: "rgba(25, 25, 25, 0.85)",
        backdropFilter: "blur(4px)",
        color: "white",
        padding: "6px 16px",
        borderRadius: "16px",
        border: "1px solid rgba(255,255,255,0.15)",
        pointerEvents: "auto",
        minWidth: "120px",
        textAlign: "center",
        cursor: "pointer",
        transition: "all 0.3s ease-in-out", // Smooth transition effect

        // MUI Hover state selector
        "&:hover": {
          border: "1px solid rgba(255,255,255,0.4)",
          backgroundColor: "rgba(40, 40, 40, 0.95)",
          transform: "scale(1.05)", // Subtle pop-out effect on hover
        },
      }}
    >
      <Typography
        sx={{
          fontSize: "11px",
          fontWeight: "bold",
          letterSpacing: "1px",
          color: isHovered ? "#4caf50" : "rgba(255, 255, 255, 0.5)", // Changes color on hover
          transition: "color 0.2s ease",
          display: "block",
          textTransform: "uppercase",
        }}
      >
        {isHovered ? "Commit Hash" : "Git Branch"}
      </Typography>

      <Typography
        sx={{
          fontSize: "13px",
          fontWeight: "medium",
          color: "white",
          display: "block",
          fontFamily: "monospace", // Makes hashes look clean and aligned
        }}
      >
        {isHovered ? version : branch}
      </Typography>
    </Box>
  );
}
